<template>
  <div class=wrapper>
    <div id=player class=player ref=player></div>
    <v-icon style="display:none" @click="back" class="highlight_off">highlight_off</v-icon>
  </div>
</template>

<script>
import { db } from '@/config'
import { mapActions, mapGetters, mapMutations } from 'vuex'
const playerKey = '99d282f8-9e7a-4bbb-bd1c-5e4ae5aaef0a'
const analyticsKey = '7ceb7c06-ebd7-4ea8-b9da-c5d691831e62'

export default {
  name: 'Video',
  data () {
    return {
      fromTimestamp: false,
      player: null,
      session: null,
      sessionRef: null,
      modalData: null,
      setupInit: null,
      pid: null,
      activePid: null,
      playingVideo: false,
      first_play_event: 'first_play',
      lightbox: false,
      program: null,
      lightbox: null
    }
  },
  computed: {
    // ...mapGetters(['program'])
  },
  async created () {
  },
  async activated () {
    this.fromTimestamp = this.$route.query.timestamp
    this.program = await this.getProgramBySlug(this.$route.params.slug)
    this.modalData = this.program
    this.init()

    console.log({activated: true, program: this.program})

    window.addEventListener("beforeunload", (e) => {
      this.beforeExit()
      return true
    });
    this.first_play_event = 'first_play'
    document.querySelector('footer').style.display = 'none'
    this.lightbox = [
      'sun_presentacionesperanza',
      'sun_presentaciontambienlalluvia',
      'sun_presentacionbajarsealmoro',
      'sum_presentacionadiosalareina',
      'sun_presentacionlanochependelton'
    ].includes(this.$route.params.slug)

    if (this.lightbox) {
      try {
        document.querySelector('nav').style.display = 'none'
        document.querySelector('main').style.padding = '32px 0 0'
        document.querySelector('.highlight_off').style.display = 'block'
        document.body.style.width = '90vw'
        document.body.style.margin = 'auto'
      } catch(_) {}
    }
  },
  deactivated() {
    document.querySelector('footer').style.display = 'block'
    if (this.lightbox) {
      try {
        document.querySelector('nav').style.display = 'block'
        document.querySelector('main').style.padding = '64px 0 0'
        document.querySelector('.highlight_off').style.display = 'none'
        document.body.style.width = '100vw'
        document.body.style.margin= '0'
      } catch(_) {}
    }
  },
  methods: {
    ...mapActions(['getProgramBySlug', 'userData', 'log_video_views']),
    ...mapMutations(['setVideoBack']),
    setup () {
      console.log('Video', '{{setupInit}}', this.setupInit)
      console.log('Video', '{{user}}', this.$store.getters.user)
      console.log('Video', '{{this.modalData}}', this.modalData.slug, this.setupInit)
      console.log('Video', '{{this.player}}', this.player)

      if (this.setupInit) return;
      // if (this.player) return;
      this.modalData = this.modalData || this.program
      const user = this.$store.getters.user
      if (user == null) {
        this.$bvueUi.modal.close()
        console.log('Video', 'ERROR: trying to see video unregistered user')
        return
      }

      this.modalData.video.dash = this.modalData.video.dash
        .replace('https://storage.googleapis.com/planet-horror.appspot.com', 'https://cdn.planethorror.es')
      this.modalData.video.hls = this.modalData.video.hls
        .replace('https://storage.googleapis.com/planet-horror.appspot.com', 'https://cdn.planethorror.es')

      const poster = this.modalData.video.media && this.modalData.video.media.lg ? this.modalData.video.media.lg : this.modalData.video.poster

console.log({hls: this.modalData.video.hls})
      const config = {
        key: playerKey,
        // ui: false,
        cast: {
          enable: 'true',
        },
        skin: {
          screenLogoImage: ""
        },
        remotecontrol: {
          type: 'googlecast',
          customReceiverConfig: {
            receiverStylesheetUrl: "https://festival-microsite.web.app/player.css"
          }
        },
        analytics: {
          key: analyticsKey,
          videoId: this.modalData.slug,
          title: this.modalData.video.master_file_name || 'filename',
          customData1: user.uid, // User id
          customData2: this.modalData.id, // Program id
          customData3: this.modalData.slug, // Program slug
          customData4: this.modalData.video.master_file_name || 'filename' // Filename
        },
        source: {
          dash: this.modalData.video.dash,
          hls: this.modalData.video.hls,
          poster: poster,
          drm: {
            widevine: {
              LA_URL: 'https://widevine-dash.ezdrm.com/proxy?pX=80BA2D'
            },
            playready: {
              LA_URL: 'https://playready.ezdrm.com/cency/preauth.aspx?pX=A8DC04'
            },
            fairplay: {
              LA_URL: 'https://fps.ezdrm.com/api/licenses/00002BC7-2E2E-446D-9F9F-C3E84D29DF07',
              certificateURL: location.protocol + '//' + location.host + '/' + 'fairplay.cer',
              prepareContentId: function(contentId) {
                var uri = contentId;
                var uriParts = uri.split('://', 1);
                var protocol = uriParts[0].slice(-3);
                uriParts = uri.split(';', 2);
                contentId = uriParts.length > 1 ? uriParts[1] : '';
                uriParts = contentId.split('?', 2);
                contentId = uriParts.length > 1 ? uriParts[0] : contentId;
                return protocol.toLowerCase() == 'skd' ? contentId : '';
              },
              prepareLicenseAsync: function(ckc) {
                return new Promise(function(resolve, reject) {
                  const reader = new FileReader();
                  reader.addEventListener('loadend', function() {
                    resolve(new Uint8Array(reader.result));
                  });
                  reader.addEventListener('error', function() {
                    reject(reader.error);
                  });
                  reader.readAsArrayBuffer(ckc);
                });
              },
              prepareMessage: function(event, session) {
                return new Blob([event.message], {type: 'application/octet-binary'});
              },
              headers: {'content-type': 'application/octet-stream'},
              useUint16InitData: true,
              licenseResponseType: 'blob'
            }
          }
        }
      }

      this.modalData.video = {...this.modalData.video, ...config.source}
      
      console.log('Video', '**********************************************')
      console.log('Video', "bitmovin.player('player')")
      console.log('Video', document.querySelector('.wrapper'))
      let player = bitmovin.player('player');
      console.log('Video', {player})
      console.log('Video', '**********************************************')

      this.player = player
      this.setupInit = !!this.modalData && !!player
      if (!this.setupInit) return

      player.setup(config).then((value) => {
        // Success
        clearInterval(this.pid)
        player.play()
        console.log('Video', 'Successfully created bitmovin player instance');
        const session = {
          program_slug: this.modalData.slug,
          user_id: user.uid,
          date: new Date().getTime(),
          duration: 0,
          device_id: this.$store.state.deviceId,
          ip: this.$store.state.ip || null,
          prefered_language_audio: 'es',
          prefered_language_subtitulos: 'es'
        }
        this.session = session
        const ref = db.collection('log_video_views').doc()
        this.sessionRef = ref
        ref.set(this.session)

        const data = {
          created_at: new Date(),
          slug: this.modalData.slug,
          user_id: user.uid || user.id ,
          date: new Date().getTime(),
          device_id: this.$store.state.deviceId,
          ip: this.$store.state.ip || null
        }
        db.collection('stats_video_views').add(data)
      }, (reason) => {
        // Error!
        console.log('Video', {reason})
        history.go(-1)
        this.player.destroy()
        // document.querySelector('#player').innerHTML = ''
        this.setupInit = null
        console.log('Video', 'Error while creating bitmovin player instance');
      });

      // // EVENTS
      this.player.addEventHandler(bitmovin.player.EVENT.ON_PLAYING, () => {
        console.log('Video', 'player is playing', this.$store.getters.user)
        if (this.fromTimestamp) {
          this.fromTimestamp = false
          console.log('user', this.$store.getters.user, this.modalData)
          db.collection('users_videos_last_times')
            .doc(this.$store.getters.user.uid)
            .collection('videos')
            .doc(this.modalData.id || this.modalData.slug)
            .get().then((doc) => {
              var data = doc.data()
              console.log('Video', '{timestamp}', data)
              if (data && data.timestamp) {
                this.player.seek(data.timestamp)
              }
              this.log_video_views({
                event: this.first_play_event,
                program_slug: this.modalData.slug,
                duration: data.timestamp || 0
              })
              this.first_play_event = 'play'
            })
        } else {
          console.log('Video', Math.round(this.player.getCurrentTime()))
          this.log_video_views({
            event: this.first_play_event,
            program_slug: this.modalData.slug,
            duration: Math.round(this.player.getCurrentTime())
          })
          this.first_play_event = 'play'
          console.log('Video', bitmovin.player.EVENT)
        }
      })

      this.player.addEventHandler(bitmovin.player.EVENT.ON_PAUSED, () => {
        console.log('Video', '...pause...')
        this.log_video_views({
          event: 'pause',
          program_slug: this.modalData.slug,
          duration: Math.round(this.player.getCurrentTime())
        })
      })

      this.player.addEventHandler(bitmovin.player.EVENT.ON_DESTROY, async () => {
        console.log('Video', 'player destroyed')
        console.log('Video', 'session:', this.session)
        if (this.session) {
          const duration = (new Date().getTime()) - this.session.date
          console.log('Video', 'duration:', duration)
          console.log('Video', '[this.sessionRef]' ,this.sessionRef)
          if (this.sessionRef) await this.sessionRef.update({ duration: duration })
        } else {
          if (this.sessionRef) await this.sessionRef.update({ duration: Math.round(this.player.getCurrentTime()) })
        }
        console.log('Video', '..............')
      })

    },
    async init () {
      this.startActiveUser()
      this.setVideoBack(true)
      clearInterval(this.pid)
      this.pid = setInterval(() => {
        console.log('Video', '**************(SETUP)**************', this.modalData.slug, this.$route.params.slug)
        if (this.modalData && this.modalData.slug === this.$route.params.slug) {
          this.setup()
        }
      }, 1000)
      console.log('Video', 'PID', this.pid)
    },
    startActiveUser() {
      clearInterval(this.activePid)
      this.doActiveTick()
      this.activePid = setInterval(() => {
        this.doActiveTick()
      }, 300000)
    },
    doActiveTick() {
      console.log('Video', '**************(TICK ACTIVE USER)**************')
      db.collection('active_users')
      .doc(this.$store.getters.user.uid)
      .set({
        lastPlay: new Date().getTime()
      })
    },
    removeActiveUser() {
      clearInterval(this.activePid)
      db.collection('active_users')
      .doc(this.$store.getters.user.uid)
      .delete()
    },
    async beforeExit() {
      this.setVideoBack(false)
      console.log('beforeExit:Video', '<beforeRouteLeave>')
      console.log('beforeExit:Video', 'player destroy', this. player)
      clearInterval(this.pid)
      this.removeActiveUser()
      this.setupInit = null
      // const id = this.modalData.id
      
      if (this.player) {
        console.log('Video', 'player destroy')
        const allTime = this.player.getDuration()
        var current = this.player.getCurrentTime()

        console.log('beforeExit:Video', this.modalData.id, {allTime, current})
        console.log('beforeExit:Video', 'this.$store.getters.user.uid: ', this.$store.getters.user.uid)
        console.log('beforeExit:Video', this.modalData)
        // db.collection('users_videos_last_times')
        //   .doc(this.$store.getters.user.uid)
        //   .collection('videos')
        //   .doc(this.modalData.slug).set({
        //     id: this.modalData.id,
        //     timestamp: current,
        //     duration: allTime,
        //     progress: 100 * (current || 0) / (allTime || 1)
        //   }, { merge: true })
        //
        console.log('beforeExit:set?', `users_videos_last_times/${this.$store.getters.user.uid}/videos/${this.modalData.slug}`)
        try {
          await db.doc(`users_videos_last_times/${this.$store.getters.user.uid}`).set({
            updated_at: new Date()
          })
          await db.doc(`users_videos_last_times/${this.$store.getters.user.uid}/videos/${this.modalData.id}`).set({
            id: this.modalData.id,
            slug: this.modalData.slug,
            timestamp: current,
            duration: allTime,
            progress: 100 * (current || 0) / (allTime || 1),
            user_id: this.$store.getters.user.uid
          }, { merge: true })
        } catch(error) {
          console.error(error)
        }

        this.player.destroy()
        // const duration = (new Date().getTime()) - this.session.date
        // this.sessionRef.update({duration: duration})
      } 
      // console.log('Video', {to}, to.name)
      try {
      this.log_video_views({
        event: 'exit',
        program_slug: this.modalData.slug,
        duration: Math.round(this.player ? this.player.getCurrentTime() : 0)
      })
      } catch(error) {console.error(error)}
      this.modalData = null
    },
    back() {
      history.back()
    }
  },
  watch: {
    program () {
      console.log('Video', '--WATCH--', 'program')
      this.modalData = this.program
      // this.init()
    },
    // async '$route' (to, from, other) {
    //   console.log('Video', '--WATCH--', 'route')
    //   console.log('Video', 'NAME-ID', to.name, to.params)
    //   if (to.name === 'Video' && to.params.id) {
    //     this.fromTimestamp = this.$route.query.timestamp
    //     await this.getProgram(this.$route.params.id)
    //     this.modalData = this.program
    //     this.init()
    //   } else if (to.name === 'Video' && to.params.slug) {
    //     this.fromTimestamp = this.$route.query.timestamp
    //     await this.getProgramBySlug(this.$route.params.slug)
    //     this.modalData = this.program
    //     this.init()
    //   }
    // },
    // userData () {
    //   console.log('Video', '--WATCH--', 'userData')
    //   this.setup()
    // }
  },
  // async beforeRouteUpdate (to, from, next) {
  //   console.log('Video', '<beforeRouteUpdate>')
  //   this.fromTimestamp = this.$route.query.timestamp
  //   await this.getProgram(this.$route.params.id)
  //   if (!this.modalData) {
  //     this.modalData = this.program
  //     this.modalData && this.setup()
  //   }
  //   next()
  // },
  beforeRouteLeave (to, from, next) {
    this.beforeExit()
    console.log('Video', '[NEXT]')
    next()
  }
}
</script>
<style scoped>
.wrapper {
  background: black;
  width: 100%;
  height: calc(100vh - 64px);
}
.player {
  width: 100%;
  height: 100%;
  margin: auto;
  box-shadow: 0px 0px 56px 0px rgba(0, 0, 0, 0.75);
}
.highlight_off {
  position: absolute;
  top: -13px;
  right: 5px;
  zoom: 2;
  background: gray;
  box-shadow: 0 0 black;
  border-radius: 50%;
}
</style>
<style>
/*.bmpui-ui-playbacktoggle-overlay {
  opacity: 0;
}
.bmpui-player-state-playing .bmpui-ui-playbacktoggle-overlay {
  opacity: 0 !important;
}
.bmpui-controls-hidden .bmpui-ui-playbacktoggle-overlay {
  opacity: 0 !important;
}
.bmpui-controls-shown .bmpui-ui-playbacktoggle-overlay {
  opacity: 1 !important;
}*/
.bmpui-ui-watermark {
  display: none !important;
}
</style>